import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { Tag } from "src/app/data/schema/Courses/Tag";
import { PatchUseInterestsTO } from "src/app/data/schema/User/PatchUserInterestsTO";
import { UsuarioTO } from "src/app/data/schema/User/UsuarioTO";
import { ProfileService } from "../../services/profile.service";

@Component({
    selector: "app-profile-interests",
    templateUrl: "./profile-interests.component.html",
    styleUrls: ["./profile-interests.component.scss"]
})
export class ProfileInterestsComponent implements OnInit, OnDestroy {
    private userSubscription: Subscription;
    private categoriesSubscription: Subscription;
    private user: UsuarioTO;

    public loading$: Observable<boolean>;
    public editMode: boolean;
    public tags: Tag[] = new Array<Tag>();

    constructor(private profileService: ProfileService) {
        this.editMode = false;

        this.loading$ = this.profileService.getLoadingAsync();

        this.categoriesSubscription = this.profileService.getCategoriesAsync().subscribe((categories) => {
            if (categories) {
                categories.forEach((element) => this.tags.push(new Tag(element)));
                this.selectCourseTags();
            }
        });

        this.userSubscription = this.profileService.getUserAsync().subscribe((user) => {
            if (user) {
                this.user = user;
                this.selectCourseTags();
            }
        });
    }

    ngOnInit(): void {
        this.profileService.getLoggedUser();
        this.profileService.fetchCategories();
    }

    ngOnDestroy(): void {
        this.userSubscription.unsubscribe();
        this.categoriesSubscription.unsubscribe();
        this.profileService.clear();
    }

    toggleEdition(): void {
        if (this.editMode) {
            this.save();
        }

        this.editMode = !this.editMode;
    }

    private save(): void {
        let mainTags = new Array<string>();
        let childrenTags = new Array<string>();

        this.tags
            .filter((tag) => tag.selected)
            .forEach((element) => {
                mainTags.push(element.nome);
            });

        this.tags
            .filter((tag) => tag.selected)
            .forEach((element) => {
                element.subCategorias
                    .filter((child) => child.selected)
                    .forEach((e) => {
                        childrenTags.push(e.nome);
                    });
            });

        const patch: PatchUseInterestsTO = {
            tagsInteressesPrincipais: mainTags,
            tagsInteressesDetalhes: childrenTags
        };

        this.profileService.updateUserInterests(patch);
    }

    private selectCourseTags = (): void => {
        if (!this.user || this.tags?.length <= 0) return;

        this.tags.forEach((tag) => {
            tag.selected = this.user.tagsInteressesPrincipais.includes(tag.nome);

            tag.subCategorias.forEach((sub) => {
                sub.selected = this.user.tagsInteressesDetalhes.includes(sub.nome);
            });
        });
    };

    public selectMainTag(id: string): void {
        if (!this.editMode) return;

        var selectedTag = this.tags.filter((tag) => tag.id === id)[0];
        selectedTag.selected = !selectedTag.selected;

        for (let index = 0; index < selectedTag.subCategorias.length; index++) {
            const child = selectedTag.subCategorias[index];
            child.selected = false;
        }
    }

    public getSelectedTags(): Tag[] {
        return this.tags.filter((tag) => tag.selected);
    }

    public selectChildrenTag(idParent: string, idChild: string): void {
        var selectedParentTag = this.tags.filter((tag) => tag.id === idParent)[0];

        var selectedTag = selectedParentTag.subCategorias.filter((child) => child.id === idChild)[0];
        selectedTag.selected = !selectedTag.selected;
    }
}
